import React from "react";
import Layout from "../../components/layout";
import placement from "../../images/asthmagram-placement.png";
import userstoryAsth from "../../images/user-story_asth.png";
import prototype from "../../images/asthmagram-prototype.jpg";

const Asthmagram = () => {

  return (
    <Layout>
      <div className="product">
        <section className="product-title">
          <div className="product-title__container">
            <h1 className="heading-primary u-margin-bottom-small">
              <span className="heading-primary--main">Asthmagram</span>
            </h1>
          </div>
        </section>
        <section className="product-content">
          <div className="row u-margin-bottom-small">
            <h2 className="heading-secondary product-content__title">
              Intended for use
            </h2>
          </div>
          <div className="row">
            <p className="paragraph">
              Asthmagram is a novel and innovative way of assessing asthma
              control and therapeutic efficacy in children. It is based on the
              latest wearable sensors, system-on-chip and mobile technologies,
              for non-intrusive, comfortable, and continuous monitoring for up
              to 1 to 2 weeks.
            </p>
          </div>
          <div className="row">
            <div className="col-1-of-3 product-img">
              <img src={placement} alt="placement" className="product-img__md"/>
            </div>
            <div className="col-2-of-3">
              <p className="paragraph">
                The Asthmagram device is a 4 x 2 x 0.8 cm recorder housed in a 6
                x 2 cm elongated patch, shaped like a Band-Aid. It is placed at
                the suprasternal notch, straddled over the sternocleidomastoid
                (SCM) muscles on either end, on top of the trachea. This
                placement will (1) maximize the capture of breath sounds from
                both lungs, including wheezes and coughs; (2) enable detection
                of suprasternal retractions; (3) provide accurate assessment of
                body posture and movement. The patch is water-resistant, so the
                child can shower or bath with the patch on. The adhesive beneath
                the patch provides attachment to the skin for 7 days. The device
                can be wirelessly connected to mobile devices, which can display
                and send alerts.
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-2-of-3" style={{alignSelf: 'flex-end'}}>
              <p className="paragraph">
                Once Asthmagram test is ordered by clinicians, the nurse
                prepares the child’s skin and places the patch. The child wears
                the patch continuously for up to 7 days, then removes the patch
                and puts it in the return envelope. Upon arrival at our center,
                the operator downloads and analyzes the recordings by computer
                algorithms, and generates an “Asthmagram Report”. The report is
                sent to the ordering physician immediately by mail or by a
                HIPAA-enabled email server for his/her review and diagnosis. By
                quantitating the frequency of daytime and nocturnal wheezing and
                coughs, practitioners can objectively assess symptom control and
                tailor therapy accordingly. Furthermore, Asthmagram enables
                accurate exercise and post-exercise assessment of wheezing.
              </p>
            </div>
            <div className="col-1-of-3 product-img">
              <img src={prototype} alt="prototype" className="product-img__md"/>
            </div>
          </div>
          <div className="row u-margin-bottom-small u-center-text">
            <h2 className="heading-secondary product-content__title">
              How to use
            </h2>
          </div>
          <div className="row" style={{justifyContent: "center"}}>
            <img src={userstoryAsth} alt="asthmagram" className="product-img__asth"/>
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default Asthmagram;
